import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Ear } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function Partners() {
  const [networks, setNetworks] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/networks").then(async (r) => {
      const nets = r.data.networks || [];
      setNetworks(nets);
      const c = {};
      for (const n of nets) {
        const cr = await api.get("/centers", { params: { network: n.slug, limit: 1 } });
        c[n.slug] = cr.data.count;
      }
      setCounts(c);
    });
  }, []);

  return (
    <div>
      <section className="hero-bg py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Partenaires officiels</div>
          <h1 className="font-heading text-4xl sm:text-5xl text-primary-blue mt-3">Des réseaux de confiance à votre service</h1>
          <p className="mt-6 text-lg text-slate-700 max-w-3xl">
            Audition Expert collabore exclusivement avec des enseignes reconnues, sélectionnées pour leur expertise
            et la qualité de leur accueil.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-8">
        {networks.map((n) => (
          <div key={n.slug} className="p-8 bg-white rounded-2xl border border-slate-100 card-lux flex flex-col" data-testid={`partner-card-${n.slug}`}>
            <div className="w-14 h-14 rounded-xl bg-sky-blue flex items-center justify-center">
              <Ear size={26} className="text-primary-blue" />
            </div>
            <div className="mt-6 font-heading text-2xl text-primary-blue">{n.name}</div>
            <p className="mt-3 text-slate-700 flex-1">{n.description}</p>
            <div className="mt-4 text-sm text-slate-500">{counts[n.slug] ?? "…"} centres partenaires</div>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to={`/centres?network=${n.slug}`}>
                <Button variant="outline" className="border-primary-blue text-primary-blue">Voir les centres</Button>
              </Link>
              {n.website && (
                <a href={n.website} target="_blank" rel="noreferrer">
                  <Button variant="ghost" className="text-slate-700">
                    Site officiel <ExternalLink size={14} className="ml-2" />
                  </Button>
                </a>
              )}
            </div>
          </div>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24">
        <div className="rounded-2xl bg-sky-blue/60 p-8 border border-primary-blue/10 text-slate-700">
          <p>
            Chaque centre partenaire reste responsable de ses prestations, de ses disponibilités et de ses professionnels.
            Audition Expert n'est pas un prestataire médical mais un intermédiaire facilitant la prise de rendez-vous.
          </p>
        </div>
      </section>
    </div>
  );
}
